import state from './userManagementState'
import actions from './userManagementActions'
import getters from './userManagementGetters'
import mutations from './userManagementMutations'

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}
